import type {FlatTocEntry} from "./tocUtils";
import classes from "./TocTickRail.module.css";

interface TocTickRailProps {
    entries: FlatTocEntry[];
    currentId?: string | null;
    onPointerEnter?: () => void;
    onPointerLeave?: () => void;
    /** True while the text list is open. The rail then fades out. */
    hidden?: boolean;
}

/**
 * Miniature TOC rail. Show one tick per heading.
 * The rail is decorative. The text TOC stays the accessible navigation.
 */
export const TocTickRail = ({
    entries,
    currentId,
    onPointerEnter,
    onPointerLeave,
    hidden = false,
}: TocTickRailProps) => {
    if (entries.length === 0) return null;

    const currentIndex = currentId
        ? entries.findIndex((entry) => entry.id === currentId)
        : -1;

    return (
        <div
            className={`${classes.rail} ${hidden ? classes.hidden : ""}`}
            aria-hidden="true"
            onPointerEnter={onPointerEnter}
            onPointerLeave={onPointerLeave}
        >
            {entries.map((entry, index) => {
                const state =
                    currentIndex === -1
                        ? "upcoming"
                        : index === currentIndex
                            ? "current"
                            : index < currentIndex
                                ? "read"
                                : "upcoming";
                const depthClass = entry.depth === 0 ? classes.top : classes.sub;

                return (
                    <span
                        key={entry.id}
                        data-state={state}
                        className={`${classes.tick} ${depthClass} ${classes[state]}`}
                    />
                );
            })}
        </div>
    );
};
